// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-spinkit/css/rotating-plane.css
// module id = 1235
// module chunks = 0